import { render, staticRenderFns } from "./ClientsContacts.vue?vue&type=template&id=5c87b454&"
import script from "./ClientsContacts.vue?vue&type=script&lang=js&"
export * from "./ClientsContacts.vue?vue&type=script&lang=js&"
import style0 from "./ClientsContacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports